import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { useDateOptions } from "@shared/options";

export const MagazineTemplateListFilters = React.memo(() => {
  const translate = useTranslate();
  const { getMonthOptions, getYearOptions } = useDateOptions();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="reference_month"
          label={translate("magazinetemplates.fields.reference_month")}
          options={getMonthOptions()}
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="reference_year"
          label={translate("magazinetemplates.fields.reference_year")}
          options={getYearOptions(2022)}
          required
          fullWidth
        />
      </Grid>
    </Grid>
  );
});
